import React from "react";
import embededCode from "./embeded-code";
import MobilePreview from "storybookComponents/MobilePreview";
import "./style.css";

export default React.memo(({ mobileView, ...props }) => {

  const [iframeHeight, setIframeHeight] = React.useState(0)

  React.useEffect(() => {
    const frame = document.getElementById("hylyWebIframe");
    if (!frame) return;
    frame.onload = function () {

      let height = frame.contentWindow.document.body.scrollHeight + 100;
      setIframeHeight(height + 'px')
    }
  }, [mobileView])

  let code = embededCode(props, true);
  return (
    <div style={{ minHeight: "calc(100vh - 172px)" }}>
      {
        !mobileView ?
          <div style={{ width: "100%", maxWidth: "1024px", margin: "auto", paddingBottom: 20 }}>
            <iframe id="hylyWebIframe" srcDoc={code} scrolling="no" style={{ width: "100%", border: "none", height: iframeHeight }} />
          </div>
          :
          <div style={{ width: "max-content", margin: "auto" }}>
            <MobilePreview id="p10" html={code} />
          </div>
      }
    </div>
  )
})